export const FETCH_LIST_ORGANIZATIONS_REQUEST = "FETCH_LIST_ORGANIZATIONS_REQUEST";
export const FETCH_LIST_ORGANIZATIONS_SUCCESS = "FETCH_LIST_ORGANIZATIONS_SUCCESS";
export const FETCH_LIST_ORGANIZATIONS_FAILURE = "FETCH_LIST_ORGANIZATIONS_FAILURE";

export const FETCH_ORGANIZATION_REQUEST = "FETCH_ORGANIZATION_REQUEST";
export const FETCH_ORGANIZATION_SUCCESS = "FETCH_ORGANIZATION_SUCCESS";
export const FETCH_ORGANIZATION_FAILURE = "FETCH_ORGANIZATION_FAILURE";

export const ADD_ORGANIZATION_REQUEST = "ADD_ORGANIZATION_REQUEST";
export const ADD_ORGANIZATION_SUCCESS = "ADD_ORGANIZATION_SUCCESS";
export const ADD_ORGANIZATION_FAILURE = "ADD_ORGANIZATION_FAILURE";

export const UPDATE_ORGANIZATION_REQUEST = "UPDATE_ORGANIZATION_REQUEST";
export const UPDATE_ORGANIZATION_SUCCESS = "UPDATE_ORGANIZATION_SUCCESS";
export const UPDATE_ORGANIZATION_FAILURE = "UPDATE_ORGANIZATION_FAILURE";

export const DELETE_ORGANIZATION_REQUEST = "DELETE_ORGANIZATION_REQUEST";
export const DELETE_ORGANIZATION_SUCCESS = "DELETE_ORGANIZATION_SUCCESS";
export const DELETE_ORGANIZATION_FAILURE = "DELETE_ORGANIZATION_FAILURE";

export const RESET_CURRENT_ORGANIZATION = "RESET_CURRENT_ORGANIZATION";
